<template>
  <article
    class="w-64 bg-white rounded-xl shadow-md overflow-hidden flex flex-col animate-pulse"
  >
    <div class="h-28 w-full bg-gray-200"></div>

    <div class="p-4 flex flex-col flex-grow space-y-3">
      <div class="h-3 w-20 bg-gray-200 rounded"></div>

      <div class="h-4 w-48 bg-gray-200 rounded"></div>
      <div class="h-4 w-40 bg-gray-200 rounded"></div>

      <div class="h-3 w-56 bg-gray-200 rounded"></div>
      <div class="h-3 w-44 bg-gray-200 rounded"></div>
      <div class="h-3 w-32 bg-gray-200 rounded"></div>

      <div class="mt-4 h-8 w-24 bg-gray-300 rounded-md"></div>

      <div class="h-3 w-24 bg-gray-200 rounded mt-4"></div>
    </div>
  </article>
</template>
